module.exports = __webpack_public_path__ + "assets/img/description-4-fe4c78bd.png";